module.exports = [{"code":1,"name":"正常"},{"code":2,"name":"故障"},{"code":3,"name":"报废"},{"code":4,"name":"未启用"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/deviceStatus.json
// module id = Rbls
// module chunks = 11